var map = {
	"./5.png": 2958,
	"./Cogna.png": 2516,
	"./Comum.png": 6987,
	"./Incomum.png": 9602,
	"./Lendária.png": 1117,
	"./Logo Horizontal - Effect Conflicting Causes 30 (1).png": 511,
	"./Rara.png": 408,
	"./Sizygii.png": 3428,
	"./Thallarsce.png": 9247,
	"./Vix.png": 7930,
	"./back_card.png": 2379,
	"./base_card_cogna.png": 6492,
	"./base_card_sizzigi.png": 4758,
	"./base_card_thallarse.png": 7901,
	"./base_card_vix.png": 5005,
	"./base_frente_img.png": 7467,
	"./destino.png": 7088,
	"./dnama.png": 3177,
	"./dominio.png": 796,
	"./enneda-face-80.png": 893,
	"./enneda.png": 8892,
	"./gnos.png": 9094,
	"./ign.png": 6473,
	"./karma.png": 8711,
	"./logo horizontal.png": 2921,
	"./logo_lazy.png": 2366,
	"./logo_lazy2.png": 2191,
	"./omna.png": 8240,
	"./primura-face-60.png": 536,
	"./primura.png": 1986,
	"./profile.png": 3556,
	"./verbus.png": 8981
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4323;